import { t } from "@lingui/macro";
import { useDialog } from "@/client/stores/dialog";
import { userFilterAmbassadorStore } from "@/client/stores/filter-ambassador";
import { FilterUserType } from "@reactive-resume/dto";
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  ScrollArea,
  Form,
  FormField,
  FormLabel,
  Input,
  FormItem,
  FormControl,
  Select,
  SelectContent,
  SelectLabel,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@reactive-resume/ui";
import { useRef } from "react";
import { useForm } from "react-hook-form";
import { SelectFormField } from "../_components/select-form-fields";

type StringFilterCondition = "startsWith" | "contains" | "equals" | "endsWith";
type NumberFilterCondition = "gt" | "gte" | "equals" | "lt" | "lte";
type DateFilterCondition = "gt" | "gte" | "equals" | "lt" | "lte";
type BooleanFilterCondition = "equals";
export type AmbassadorFormType = {
  name?: {
    condition: StringFilterCondition;
    value: string;
  };
  email?: {
    condition: StringFilterCondition;
    value: string;
  };
  // role?: {
  //     condition: NumberFilterCondition
  //     value: string
  // }
  emailVerified?: {
    condition: BooleanFilterCondition;
    value: string;
  };
  isActivated?: {
    condition: BooleanFilterCondition;
    value: string;
  };
  createdAt?: {
    condition: DateFilterCondition;
    value: string;
  };
};

const ObjectConversionToFilterType = (object: AmbassadorFormType) => {
  const filter: FilterUserType = {};
  Object.entries(object).forEach(([key, field]) => {
    if (!field || !field.value) return;

    filter[key as keyof FilterUserType] = {
      [field.condition]: field.value,
    };
  });
  return filter;
};

export const FilterAmbassadorDialog = () => {
  type FormValue = AmbassadorFormType;

  const formRef = useRef<HTMLFormElement>(null);
  const { replaceFilterAmbassador, resetFilterAmbassador } = userFilterAmbassadorStore();
  let { open, isOpen, mode, close } = useDialog("filter-ambassador");
  const form = useForm<FormValue>({
    defaultValues: {
      name: {
        condition: "contains",
        value: "",
      },
      email: {
        condition: "contains",
        value: "",
      },
      emailVerified: {
        condition: "equals",
        value: "",
      },
      isActivated: {
        condition: "equals",
        value: "",
      },
      // role: {
      //     condition: "equals",
      //     value: "",
      // },
      createdAt: {
        condition: "equals",
        value: "",
      },
    },
  });
  const OnSubmit = (data: FormValue) => {
    try {
      const filter = ObjectConversionToFilterType(data);
      console.log(filter);
      replaceFilterAmbassador(filter);
      form.reset();
      close();
    } catch {
      form.reset();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={close}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t`Filtrer les ambassadeurs`}</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <form
            ref={formRef}
            onSubmit={form.handleSubmit(OnSubmit)}
            className="flex flex-col gap-y-4"
          >
            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Nom"
                  form={form}
                  condition="String"
                  nameField="name.condition"
                />
                <Input {...form.register("name.value")} />
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Email"
                  form={form}
                  condition="String"
                  nameField="email.condition"
                />
                <Input {...form.register("email.value")} />
              </div>
            </div>
            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Activé"
                  form={form}
                  condition="Bool"
                  nameField="isActivated.condition"
                />
                <Select
                  {...form.register("isActivated.value")}
                  onValueChange={(value) => {
                    form.setValue("isActivated.value", value);
                  }}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Choisir"></SelectValue>
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectLabel>{t`Choisir une valeur`}</SelectLabel>
                      <SelectItem value="false"> Non</SelectItem>
                      <SelectItem value="true"> Oui </SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </div>
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Email verifié"
                  form={form}
                  condition="Bool"
                  nameField="emailVerified.condition"
                />
                <Select
                  {...form.register("emailVerified.value")}
                  onValueChange={(value) => {
                    form.setValue("emailVerified.value", value);
                  }}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Choisir" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectGroup>
                      <SelectLabel>{t`Choisir une valeur`}</SelectLabel>
                      <SelectItem value="false"> Non</SelectItem>
                      <SelectItem value="true"> Oui </SelectItem>
                    </SelectGroup>
                  </SelectContent>
                </Select>
              </div>
            </div>

            <div className="flex flex-row gap-2">
              <div className="flex w-1/2 flex-col gap-2">
                <SelectFormField
                  label="Inscrit le"
                  form={form}
                  condition="Date"
                  nameField="createdAt.condition"
                />
                <Input {...form.register("createdAt.value")} type="date" />
              </div>
            </div>

            <div className="flex justify-center gap-x-3">
              <Button type="submit" className="bg-moncvpro-secondary">
                {"Valider"}
              </Button>
            </div>
          </form>
        </Form>
      </DialogContent>
      <DialogFooter></DialogFooter>
    </Dialog>
  );
};
